
import React from 'react';
import styled from 'styled-components';
import up from '../../assets/up.png';
import Population from '../../components/Population/Population';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;


class CardPopulation extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
              
      <Population/>
      
            
    </Viz>
    <ReusableDetailCard
   trend= {up}
   metricsm="7.81 Billion People"
   diagnosis="Our increasing global population and industrial expansion are accelerating the depletion of precious resources."
   prediction="The world population is projected to reach 8.5 billion by 2030 (United Nations). Increasing demand for food, water and energy will almost certainly outpace the global supply, especially as the systemic impacts of climate change intensify."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />

  </Container>
  );
 }
}
export default CardPopulation;
